export default __webpack_public_path__ + "static/media/element_5.135cd699.webp";